__turbopack_context__.v({
  "disclaimer": "styles-module-scss-module__DGockG__disclaimer",
  "error_style": "styles-module-scss-module__DGockG__error_style",
  "form": "styles-module-scss-module__DGockG__form",
  "form_bg_img": "styles-module-scss-module__DGockG__form_bg_img",
  "form_container": "styles-module-scss-module__DGockG__form_container",
  "form_image": "styles-module-scss-module__DGockG__form_image",
  "form_inside_container": "styles-module-scss-module__DGockG__form_inside_container",
  "form_row": "styles-module-scss-module__DGockG__form_row",
  "form_success": "styles-module-scss-module__DGockG__form_success",
  "form_support_block": "styles-module-scss-module__DGockG__form_support_block",
  "form_support_block_text": "styles-module-scss-module__DGockG__form_support_block_text",
  "form_title": "styles-module-scss-module__DGockG__form_title",
  "form_wrapper": "styles-module-scss-module__DGockG__form_wrapper",
  "previous_step": "styles-module-scss-module__DGockG__previous_step",
  "submit_button": "styles-module-scss-module__DGockG__submit_button",
  "theme_contained": "styles-module-scss-module__DGockG__theme_contained",
  "theme_no_background": "styles-module-scss-module__DGockG__theme_no_background",
  "theme_no_padding": "styles-module-scss-module__DGockG__theme_no_padding",
  "theme_office": "styles-module-scss-module__DGockG__theme_office",
});
